import React, {useState} from "react";
import {C} from "../styles";
import "./EmailVerificationNotice.css";

// Durée de validité du lien de vérification, fixée côté serveur (POST /register et
// /resend-verification : 24 h). À garder alignée si elle change.
export const VERIFICATION_LINK_VALIDITY_HOURS = 24;

// Encadré affiché juste après l'inscription : beaucoup d'agents ne voyaient pas le simple
// message texte et oubliaient de cliquer sur le lien reçu, laissant leur compte inactif.
// `onResend` (facultatif, avec mailFailed) : renvoie l'email et rend le message à afficher ; sans lui, l'encadré
// renvoie vers le bouton « Renvoyer l'email de vérification » de la page de connexion.
export default function EmailVerificationNotice({email, pseudo, nextStep, mailFailed = false, onResend}) {
    const [resendMessage, setResendMessage] = useState("");
    const [resending, setResending] = useState(false);

    async function resend() {
        setResending(true);
        try {
            setResendMessage(await onResend());
        } catch {
            setResendMessage("Impossible de renvoyer l'email pour le moment. Réessayez dans quelques instants.");
        } finally {
            setResending(false);
        }
    }

    return (
        <div role="alert" style={{
            backgroundColor: C.accentLight,
            border: `2px solid ${C.danger}`,
            borderLeftWidth: 8,
            borderRadius: 12,
            boxShadow: "0 4px 14px rgba(192, 57, 43, 0.18)",
            padding: "16px 18px",
            margin: "0 0 16px",
            color: C.text,
        }}>
            <p style={{display: "flex", alignItems: "center", gap: 10, margin: "0 0 10px", fontSize: 19, fontWeight: 800, color: C.dangerDark}}>
                <span className="email-verification-notice__icon" aria-hidden="true" style={{fontSize: 26}}>⚠️</span>
                {mailFailed ? "Email de confirmation non envoyé" : "Dernière étape : confirmez votre adresse"}
            </p>
            {mailFailed ? (
                <>
                    <p style={{margin: "0 0 8px", fontSize: 16, lineHeight: 1.45}}>
                        Votre compte est créé mais <strong>pas encore actif</strong>, et l'email de confirmation
                        {email && <> à <strong>{email}</strong></>} <strong>n'a pas pu être envoyé</strong>.
                    </p>
                    {onResend ? (
                        <>
                            <button type="button" onClick={resend} disabled={resending}
                                    style={{border: `1px solid ${C.dangerDark}`, background: "transparent", color: C.dangerDark, borderRadius: 8, padding: "8px 14px", fontWeight: 700, cursor: "pointer"}}>
                                Renvoyer l'email de vérification
                            </button>
                            {resendMessage && <p role="status" style={{margin: "8px 0 0", fontSize: 14}}>{resendMessage}</p>}
                        </>
                    ) : (
                        <p style={{margin: 0, fontSize: 14, lineHeight: 1.45}}>
                            Pour en recevoir un nouveau : sur la page de connexion, essayez de vous connecter
                            {pseudo && <> avec le pseudo <strong>{pseudo}</strong></>}, puis cliquez sur
                            « Renvoyer l'email de vérification ».
                        </p>
                    )}
                </>
            ) : (
                <>
                    <p style={{margin: "0 0 8px", fontSize: 16, lineHeight: 1.45}}>
                        Votre compte n'est <strong>pas encore actif</strong>. Nous venons d'envoyer un email à{" "}
                        {email ? <strong>{email}</strong> : "votre adresse professionnelle"}.
                        Ouvrez-le et <strong>cliquez sur le lien de confirmation</strong>.
                    </p>
                    <p style={{margin: "0 0 8px", fontSize: 16, fontWeight: 700}}>
                        ⏱️ Ce lien est valable {VERIFICATION_LINK_VALIDITY_HOURS} heures.
                    </p>
                    <p style={{margin: 0, fontSize: 14, lineHeight: 1.45}}>
                        Pas d'email ? Regardez dans vos courriers indésirables.
                        {pseudo && <> Ensuite, {nextStep} avec le pseudo <strong>{pseudo}</strong>.</>}
                    </p>
                </>
            )}
        </div>
    );
}
